import { render, staticRenderFns } from "./CustomizedPopup.vue?vue&type=template&id=f21d259c"
import script from "./CustomizedPopup.vue?vue&type=script&lang=js"
export * from "./CustomizedPopup.vue?vue&type=script&lang=js"
import style0 from "./CustomizedPopup.vue?vue&type=style&index=0&id=f21d259c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports